import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inner-table',
  templateUrl: './inner-table.component.html',
  styleUrls: ['./inner-table.component.scss']
})
export class InnerTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
